import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ArrowThinUpIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 20.25v-16.5M5.25 10.5 12 3.75 18.75 10.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  )
}
